import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EColType, ICol } from '@bixi/core/table';
import { transformFileSize } from '@mining/ui/core/util';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
@Component({
  selector: 'm-upload-single-file',
  exportAs: 'mUploadSingleFile',
  template: `
    <div *ngIf="mFileList.length" class="m-upload-single-file">
      <div class="m-upload-single-container">
        <p *ngIf="mSingFileIcon"><img [src]="mSingFileIcon" alt="文件icon" /></p>
        <div>{{ file.name }}</div>
        <nz-upload [nzMultiple]="false" [nzBeforeUpload]="beforeUpload" [nzAccept]="mAcceptFileType">
          <button nz-button nzType="link">重新上传</button>
        </nz-upload>
      </div>
      <div class="m-upload-single-container-footer">
        <button *ngIf="mShowFooterBtn && mBtnDesc !== ''" nz-button nzType="primary" (click)="onCreateTask()">{{ mBtnDesc }}</button>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MUploadSingleFileComponent {
  @Input() mFileList: NzUploadFile[] = [];
  @Input() mMultiple = true;
  @Input() mBtnDesc = '';
  @Input() mAcceptFileType = '';
  @Input() mShowFooterBtn = true;
  @Input() mSingFileIcon = '';
  @Output() readonly mCreateTask = new EventEmitter<NzUploadFile[]>();
  @Output() readonly mFileListChange = new EventEmitter<NzUploadFile[]>();

  constructor(protected msg: NzMessageService) {}

  cols: ICol[] = [
    {
      name: '文件名称',
      key: 'name',
      ellipsis: true,
      width: '65%'
    },
    {
      name: '大小',
      key: 'sizeValue',
      width: '150px'
    },
    {
      name: '操作',
      key: 'action',
      width: '100px',
      type: EColType.operations,
      operations: () => {
        return [
          {
            name: '删除',
            onClick: (item: NzUploadFile) => {
              this.deleteFileItem(item);
            }
          }
        ];
      }
    }
  ];
  get file(): NzUploadFile {
    return this.mFileList[0];
  }

  deleteFileItem(item: NzUploadFile): void {
    this.mFileList = this.mFileList.filter(ele => ele.uid !== item.uid);
    this.mFileListChange.emit(this.mFileList);
  }

  onCreateTask(): void {
    this.mCreateTask.emit(this.mFileList);
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    if (file.name.length > 255) {
      this.msg.error('文件名称过长，请修改后重新上传（名称应小于255字）');
      return false;
    }
    file.sizeValue = transformFileSize(file.size as number);
    this.mFileList = [file];
    this.mFileListChange.emit(this.mFileList);
    return false;
  };
}
